import { useCallback, useEffect,useMemo,useState } from "react";
import apiRoute from "routes/apirRoutes";
import http from "services/httpService";
import { buildQuery } from "services/MiscService";

export default function useUserLoans(queryObject){
    const [userLoans,setUserLoans] = useState([]);
    const [loading,setLoading] = useState(false);

    const query = useMemo(()=>{
        return buildQuery(queryObject);
    },[queryObject])

    // TODO: remove repeated function after better research
     const getLoans= useCallback(async()=>{
        setLoading(true)
        try {
          const res = await http.get(apiRoute.loanUser + query)
        setLoading(false)
        if(res.data){
            setUserLoans(res.data.data)
        }
        }finally{
            setLoading(false)
        }
    },[query])

    useEffect(()=>{
        getLoans()
    },[getLoans])

    return {
        loading,
        userLoans,
        getLoans
    }
}